module.exports = __webpack_public_path__ + "img/28f.26c2acff.png";